// 生成树结构
import isObject from 'lodash/isObject';
function toTree(data) {
  let result = []
  if(!Array.isArray(data)) {
    return result
  }
  data.forEach(item => {
    delete item.children;
  });
  let map = {};
  data.forEach(item => {
    map[item.id] = item;
  });
  data.forEach(item=> {
    let parent = map[item.parentId];
    if(parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
      result.push(item);
    }
  });
  return result;
}

// 查找树节点
function treeFind(tree, func) {
	for (const data of tree) {
		if (func(data)) return data
		if (data.children) {
			const res = treeFind(data.children, func)
			if (res) return res
		}
	}
	return null
}

// 查找节点路径
function treeFindPath(tree, func, path = []) {
	if (!tree) return []
	for (const data of tree) {
		path.push(data)
		if (func(data)) return path
		if (data.children) {
			const findChildren = treeFindPath(data.children, func, path)
			if (findChildren.length) return findChildren
		}
		path.pop()
	}
	return []
}

function flattenTree(tree) {
  if (!tree) {
    return [];
  }
  return tree.reduce((resultList, item) => {
    const { children, ...others } = item;
    if ((children || []).length > 0) {
      return [...resultList, others, ...flattenTree(children)];
    }
    return [...resultList, others];
  }, [])
}

export {
  toTree,
  treeFind,
  treeFindPath,
  flattenTree
}


// WEBPACK FOOTER //
// ./src/utils/tree.js